import { ContractOwnerUtil } from '@/utils/ContractOwner'

export const ContractOwnerHelper = {
  ...ContractOwnerUtil
}
